<template>
  <div class="home">
    <HeaderLandingNew />
    <div class="section-one section-premium">
      <div class="so-content">
        <h1>Go Premium for as low as $1!</h1>
        <p>
          Enjoy listening to songs in full, listen to songs offline,
          and share to missions. Cancel anytime!
        </p>
        <div class="so-content-action on-home">
          <a class="btn primary" :href="'/#/subscribe'" aria-label="Get MusicVerse"
          >Get MusicVerse</a
          >
          <a class="btn outline" :href="url" aria-label="Learn More MusicVerse">
            Learn More MusicVerse
          </a>
        </div>
      </div>
    </div>
    <div class="container-section ">
      <div class="content-section-2">
        <div class="section-premium-content">
          <div class="section-premium-header">
            <h1 class="premium-title">Premium Perks</h1>
            <div class="premium-subtitle">Payment partners</div>
            <div class="payment-partners d-flex justify-content-center">
              <img src="@/assets/visa.png" alt="logo" />
              <img src="@/assets/master.png" alt="logo" />
              <img src="@/assets/american-express.png" alt="logo" />
              <!--                <img src="@/assets/grabpay.png" alt="logo" />-->
              <!--                <img src="@/assets/gcash.png" alt="logo" />-->
              <img src="@/assets/wechat.png" alt="logo" />
              <img src="@/assets/apple-pay.png" alt="logo" v-if="canApplePay"/>
            </div>
          </div>
          <div class="spc-box-container">
            <div class="spc-box-item">
              <div class="spc-box-title">Free</div>
              <div class="spc-box-start-form">Starts from</div>
              <div class="spc-box-price">
                <span class="spc-box-amount">$0</span>
                <span class="spc-box-per-month">/month</span>
              </div>
              <div class="spc-box-divider"></div>
              <ul class="spc-box-plan-list">
                <li class="spc-box-plan-item">
                  <img
                    src="@/assets/times.svg"
                    class="spc-box-plan-icon"
                    alt="icon"
                  />
                  <span>Ads interuption</span>
                </li>
                <li class="spc-box-plan-item">
                  <img
                    src="@/assets/times.svg"
                    class="spc-box-plan-icon"
                    alt="icon"
                  />
                  <span>Play on shuffle mode</span>
                </li>
                <li class="spc-box-plan-item">
                  <img
                    src="@/assets/times.svg"
                    class="spc-box-plan-icon"
                    alt="icon"
                  />
                  <span>Streaming only, can’t listen offline</span>
                </li>
              </ul>
              <div class="spc-box-action">
                <a
                  :href="url"
                  class="btn outline-primary"
                  aria-label="Start for Free"
                >Start for Free</a
                >
              </div>
            </div>
            <div class="spc-box-item">
              <div class="spc-box-title">Premium</div>
              <div class="spc-box-start-form">Starts from</div>
              <div class="spc-box-price">
                <span class="spc-box-amount">$1</span>
                <span class="spc-box-per-month">/month</span>
              </div>
              <div class="spc-box-divider"></div>
              <ul class="spc-box-plan-list">
                <li class="spc-box-plan-item">
                  <img
                    src="@/assets/check.svg"
                    class="spc-box-plan-icon"
                    alt="icon"
                  />
                  <span>No ads interuption</span>
                </li>
                <li class="spc-box-plan-item">
                  <img
                    src="@/assets/check.svg"
                    class="spc-box-plan-icon"
                    alt="icon"
                  />
                  <span>Play anything</span>
                </li>
                <li class="spc-box-plan-item">
                  <img
                    src="@/assets/check.svg"
                    class="spc-box-plan-icon"
                    alt="icon"
                  />
                  <span>Skip anytime you want</span>
                </li>
                <li class="spc-box-plan-item">
                  <img
                    src="@/assets/check.svg"
                    class="spc-box-plan-icon"
                    alt="icon"
                  />
                  <span>Listen offline</span>
                </li>
                <li class="spc-box-plan-item">
                  <img
                    src="@/assets/check.svg"
                    class="spc-box-plan-icon"
                    alt="icon"
                  />
                  <span
                  >Listen to scripture song’s instrumental accompaniment
                </span>
                </li>
                <li class="spc-box-plan-item">
                  <img
                    src="@/assets/check.svg"
                    class="spc-box-plan-icon"
                    alt="icon"
                  />
                  <span>Support adventist artists and missions</span>
                </li>
              </ul>
              <div class="spc-box-action">
                <a :href="url" class="btn primary" aria-label="Download"
                >Download</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterLandingNew />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import HeaderLandingNew from '@/components/HeaderLandingNew';
import FooterLandingNew from '@/components/FooterLandingNew';
import helperMixins from '@/mixins/helpers.mixins';
const MobileDetect = require('mobile-detect');
const md = new MobileDetect(window.navigator.userAgent);

const APPLE_MERCHANT_ID = process.env.APPLE_MERCHANT_ID;
export default {
  name: 'TestPage',
  mixins: [helperMixins],
  data: () => ({
    url: process.env.ALL_BUTTON_LINK,
    dataDonations: [],
    canApplePay: false,
  }),
  async mounted() {
    this.initApple();
    setTimeout(() => {
      if (md.phone()) {
        window.location = 'musicverse://gopremium';
      }
    }, 500);
  },
  methods: {
    ...mapActions('NotificationModule', ['setNextPage']),
    gotToRoute(route = 'home') {
      this.setNextPage(route === 'home' ? 'Dashboard' : 'SubscribePage');
      this.$router.push({ name: 'Registration' });
    },
    supportedByDevice() {
      return 'ApplePaySession' in window;
    },
    supportsSetup() {
      // eslint-disable-next-line no-undef
      return 'openPaymentSetup' in ApplePaySession;
    },
    initApple() {
      if (this.supportedByDevice()) {
        const can = window.ApplePaySession.canMakePayments();
        if (can) {
          this.canApplePay = true;
        } else {
          // eslint-disable-next-line max-len
          window.ApplePaySession.canMakePaymentsWithActiveCard(APPLE_MERCHANT_ID).then((canMakePayments) => {
            if (canMakePayments === true) {
              this.canApplePay = true;
            } else if (this.supportsSetup()) {
              this.canApplePay = true;
            }
          });
        }
      }
    },
  },
  components: {
    HeaderLandingNew, FooterLandingNew
  }
};
</script>

<style>
  @import '../assets/stylesheets/landing.css';
  .section-premium{
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.32) 0%, rgba(0, 0, 0, 0.32) 100%), url("~@/assets/bg-premium.jpg"), lightgray 0px -2.409px / 100% 112.294% no-repeat;
  }
  .section-premium .so-content p{
    width: 730px;
  }

  @media screen and (max-width: 500px){
    .section-premium{
      background-position: 50% 100%;
    }
    .section-premium .so-content p{
      width: 100%;
    }
  }
  .section-premium-header{
    margin-bottom: 80px;
  }
  .premium-title{
    color: #4D4D4D;
    text-align: center;
    font-size: 48px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%;
    margin-bottom: 24px;
  }
  .premium-subtitle{
    line-height: normal;
    text-align: center;
    color: #4D4D4D;
    margin-bottom: 16px;
  }
  .payment-partners{
    gap: 16px
  }
  .payment-partners img{
    height: 16px;
    width: auto;
  }
  .section-premium-content {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .spc-box-container {
    display: flex;
    gap: 40px;
  }
  @media all and (max-width: 500px) {
    .spc-box-container {
      flex-direction: column;
    }
  }
  .spc-box-container .spc-box-item {
    position: relative;
    display: flex;
    flex-direction: column;
    padding: 24px;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.12);
    min-height: 540px;
    width: 405px;
  }
  @media all and (max-width: 500px) {
    .spc-box-container .spc-box-item {
      width: unset;
      min-height: unset;
    }
  }
  .spc-box-container .spc-box-item .spc-box-title {
    color: #4d4d4d;
    font-size: 24px;
    font-weight: 700;
    line-height: normal;
    margin-bottom: 16px;
  }
  .spc-box-container .spc-box-item .spc-box-start-form {
    color: #4d4d4d;
    font-size: 12px;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 8px;
  }
  .spc-box-container .spc-box-item .spc-box-price {
    display: flex;
    align-items: flex-end;
  }
  .spc-box-container .spc-box-item .spc-box-price .spc-box-amount {
    color: #4d4d4d;
    font-size: 48px;
    font-weight: 700;
    line-height: 100%;
    margin-right: 8px;
  }
  .spc-box-container .spc-box-item .spc-box-price .spc-box-per-month {
    color: #4d4d4d;
  }
  .spc-box-container .spc-box-item .spc-box-divider {
    margin-top: 16px;
    margin-bottom: 40px;
    width: 100%;
    border-bottom: 1px solid #d9d9d9;
  }
  .spc-box-container .spc-box-item .spc-box-plan-list {
    display: flex;
    flex-direction: column;
    list-style: none;
    padding: 0;
    margin: 0;
    gap: 16px;
  }
  .spc-box-container .spc-box-item .spc-box-plan-list .spc-box-plan-item {
    display: flex;
  }
  .spc-box-container .spc-box-item .spc-box-plan-list .spc-box-plan-item .spc-box-plan-icon {
    width: 24px;
    height: 24px;
    margin-right: 16px;
  }
  .spc-box-container .spc-box-item .spc-box-action {
    position: absolute;
    width: 100%;
    padding: 24px;
    display: flex;
    bottom: 0;
    left: 0;
  }
  @media all and (max-width: 500px) {
    .section-premium-content{
      width: 100%;
    }
    .spc-box-container .spc-box-item .spc-box-action {
      position: relative;
      margin-top: 40px;
      width: 100%;
      padding: 0;
    }
  }
  .spc-box-container .spc-box-item .spc-box-action .btn {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/TestPage.vue